import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    ReferenceField,
    FunctionField,
    DateField,
    usePermissions,
    useResourceContext,
    EditButton,
    Filter,
    SearchInput,
    SelectInput
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const EnrollmentFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <SearchInput source='enrollment_number' alwaysOn placeholder="Search by enrollment number" />
        <SelectInput source='status' choices={[
            { id: 'active', name: 'Active' },
            { id: 'inactive', name: 'Inactive' },
            { id: 'completed', name: 'Completed' },
            { id: 'transferred', name: 'Transferred' },
            { id: 'withdrawn', name: 'Withdrawn' },
        ]} />
        <SelectInput source='board' choices={[
            { id: 'RBSE', name: 'RBSE' },
            { id: 'CBSE', name: 'CBSE' },
            { id: 'IGCSE', name: 'IGCSE' },
        ]} />
    </Filter>
);

export const StudentEnrollmentList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    const propsObj = processPermissions(permissions, resource);
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="Student Enrollments" 
                {...props} 
                {...propsObj}
                filters={<EnrollmentFilter />}
                sort={{ field: 'enrollment_date', order: 'DESC' }}
            >
                <Datagrid rowClick={propsObj.hasEdit ? 'edit' : false} bulkActionButtons={allowBulkActions ? undefined : false}>
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <TextField source="enrollment_number" label="Enrollment #" />
                    <ReferenceField source="student_id" reference="student" label="Student">
                        <FunctionField render={record => `${record.first_name}${record.middle_name ? ' ' + record.middle_name : ''} ${record.last_name}`} />
                    </ReferenceField>
                    <ReferenceField link={false} source="branch_id" reference="branch" label="Branch">
                        <TextField source="branch_name" />
                    </ReferenceField>
                    <ReferenceField link={false} source="program_id" reference="program" label="Program">
                        <TextField source="program_name" />
                    </ReferenceField>
                    <ReferenceField link={false} source="class_id" reference="genere" label="Class">
                        <TextField source="title" />
                    </ReferenceField>
                    <TextField source="board" label="Board" />
                    <TextField source="academic_year" label="Academic Year" />
                    <TextField source="status" label="Status" />
                    <DateField source="enrollment_date" label="Enrollment Date" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
